module.exports = __webpack_public_path__ + "img/vizibuzz_logo.38b568f3.png";